import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state/app_state';
import { changeTenant } from '../../../../../../state/advanced/tenants';
import { ETenant } from '../../../../../../../json_query';
import { getTermsValue } from '../../../../../../../json_query/reducers/helpers';

import { Tenants as TenantsComponent, ITenantsProps } from './tenants';

type TTenantStateProps = Pick<ITenantsProps, 'value'>;
type TTenantDispatchProps = Pick<ITenantsProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TTenantStateProps {
  return {
    value: getTermsValue('composition')(state.filters.jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TTenantDispatchProps {
  return {
    onChange: (tenant: ETenant, value: boolean) => {
      dispatch(changeTenant(tenant, value));
    },
  };
}

export const Tenants = connect(mapStateToProps, mapDispatchToProps)(TenantsComponent);
